import { TOKEN_KEY, USER_INFO_KEY, PERMISSIONS_KEY } from '@/config/constants'

// Several requests may fail with 401 at the same time (for example after a
// Sa-Token kickout). Keep cleanup and navigation idempotent so a burst of
// failures cannot continuously reload the login document.
let redirectingToLogin = false

export function resetLoginRedirect() {
  redirectingToLogin = false
}

export function redirectToLogin(failedToken) {
  const currentToken = localStorage.getItem(TOKEN_KEY)
  const normalize = value => value && value.startsWith('Bearer ')
    ? value.substring(7)
    : value

  // Ignore a late 401 belonging to an old request if the user has already
  // completed a new login in the meantime.
  if (failedToken !== undefined && currentToken && normalize(failedToken) !== normalize(currentToken)) return false

  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_INFO_KEY)
  localStorage.removeItem(PERMISSIONS_KEY)

  // A late response can arrive after the browser is already on /login. Do not
  // assign /login to itself, otherwise every late 401 causes another reload.
  if (window.location.pathname === '/login' || redirectingToLogin) return false

  redirectingToLogin = true
  const currentPath = window.location.pathname + window.location.search + window.location.hash
  const loginPath = currentPath && currentPath !== '/login'
    ? `/login?redirect=${encodeURIComponent(currentPath)}`
    : '/login'

  // Use the SPA router so an expired session does not force a full document
  // reload. The dynamic import avoids a router/request-interceptor cycle.
  const fallback = () => {
    if (!localStorage.getItem(TOKEN_KEY) && window.location.pathname !== '/login') {
      window.location.replace(loginPath)
    }
  }
  import('@/router')
    .then(async ({ default: router }) => {
      if (localStorage.getItem(TOKEN_KEY)) return
      // Vue Router resolves (rather than rejects) aborted/cancelled navigation.
      const failure = await router.replace(loginPath)
      if (failure) fallback()
    })
    .catch(fallback)
  return true
}
